import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const Ctx = createContext({ materials: [], reload: () => {} });

export const MaterialsProvider = ({ children }) => {
  const [materials, setMaterials] = useState([]);
  const { user } = useAuth();

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/materials");
      setMaterials(data || []);
    } catch (e) {
      console.warn("Materials load failed:", e);
    }
  }, []);

  useEffect(() => {
    if (user) reload();
  }, [user, reload]);

  const value = useMemo(
    () => ({
      materials,
      names: materials.map((m) => m.name),
      thumbnailOf: (name) =>
        materials.find((m) => m.name === name)?.thumbnail_image || null,
      coloursFor: (name) => {
        if (!name) return null;
        const m = materials.find((x) => x.name === name);
        const list = m && Array.isArray(m.colours) ? m.colours : [];
        return list.length ? list : null;
      },
      thicknessesFor: (name) => {
        if (!name) return null;
        const m = materials.find((x) => x.name === name);
        const list = m && Array.isArray(m.thicknesses) ? m.thicknesses : [];
        return list.length ? list : null;
      },
      reload,
    }),
    [materials, reload],
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useMaterials = () => useContext(Ctx);
